import { useState } from 'react';
import { api } from '../lib/api';

export interface GeoWaarde {
  adres: string;
  lat: number | null;
  lon: number | null;
  naam: string | null;
  /** true als het adres in dit formulier is aangepast */
  gewijzigd: boolean;
}

interface Resultaat { adres: string; gevonden: 'ja' | 'nee' | 'fout'; lat: number | null; lon: number | null; naam: string | null }

/** Adresveld met "🔍 Nu opzoeken" (SPEC §5 P10). Zonder opzoeken doet de worker het binnen 5 minuten. */
export function AdresVeld({ label, waarde, onChange, placeholder }: { label: string; waarde: GeoWaarde; onChange: (g: GeoWaarde) => void; placeholder?: string }) {
  const [bezig, setBezig] = useState(false);
  const [melding, setMelding] = useState<string | null>(null);
  const zoek = async () => {
    setBezig(true);
    setMelding('🔍 Bezig met opzoeken…');
    try {
      const r = await api.get<Resultaat>(`/api/geocode?q=${encodeURIComponent(waarde.adres)}`);
      if (r.gevonden === 'ja') {
        onChange({ ...waarde, lat: r.lat, lon: r.lon, naam: r.naam, gewijzigd: true });
        setMelding(`📍 ${r.naam} · wordt bewaard bij Opslaan`);
      } else if (r.gevonden === 'nee') {
        onChange({ ...waarde, lat: null, lon: null, naam: null, gewijzigd: true });
        setMelding('⚠ Niet gevonden. Controleer het adres; bij een Belgisch adres: zet er België achter');
      } else setMelding('⚠ Opzoeken lukte nu niet; na opslaan binnen 5 minuten');
    } catch {
      setMelding('⚠ Opzoeken lukte nu niet; na opslaan binnen 5 minuten');
    } finally {
      setBezig(false);
    }
  };
  const status = melding ?? (waarde.naam && !waarde.gewijzigd ? `📍 ${waarde.naam}` : waarde.adres && waarde.lat == null && !waarde.gewijzigd ? '⏳ Nog niet opgezocht' : '');
  return (
    <label className="veld">
      <span className="lbl">{label}</span>
      <div className="rij">
        <input
          value={waarde.adres}
          placeholder={placeholder ?? 'Straat huisnummer, plaats'}
          onChange={(e) => {
            setMelding(null);
            onChange({ adres: e.target.value, lat: null, lon: null, naam: null, gewijzigd: true });
          }}
        />
        <button type="button" className="knop" disabled={bezig || !waarde.adres.trim()} onClick={zoek}>
          {bezig ? 'Zoeken…' : '🔍 Nu opzoeken'}
        </button>
      </div>
      {status && <span className="klein">{status}</span>}
    </label>
  );
}
